import { useState } from 'react';
import { useFedContent } from '../content';
import { buildNovaSchedule } from './novaBracketEngine';

export default function NovaSchedule({ tour, bracket, isAdmin, fire }) {
  const saveTournament = useFedContent((state) => state.saveTournament);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState({});
  const [busy, setBusy] = useState(false);
  const schedule = buildNovaSchedule(bracket, editing ? draft : tour.matchSchedule);
  const save = async () => {
    setBusy(true);
    try {
      const current = useFedContent.getState().tournaments.find((item) => item.id === tour.id);
      if (!current) throw new Error('Турнир не найден');
      if (await saveTournament({ ...current, matchSchedule: draft })) {
        setEditing(false);
        fire('Расписание сохранено', 'success');
      } else fire('Не удалось сохранить расписание', 'error');
    } catch (error) { fire(error.message, 'error'); }
    finally { setBusy(false); }
  };
  return <section className="rounded-2xl border border-line bg-surface-2 p-5">
    <h3 className="font-display font-bold uppercase text-xl">Расписание игр</h3>
    <p className="text-fg-muted text-sm my-3">Начало в 09:30 · час на матч · время Казахстана (UTC+5). Сначала верхняя сетка групп 1–2, затем 3–4. При переходе через полночь начинается следующий день.</p>
    {isAdmin && !editing && <button type="button" className="fed-btn-ghost px-3 py-2 mb-3" onClick={() => { setDraft(tour.matchSchedule || {}); setEditing(true); }}>Изменить время игр</button>}
    <div className="overflow-x-auto">
      <table className="fed-tbl">
        <thead><tr><th>День</th><th>Время</th><th>Матч</th><th>Команды</th></tr></thead>
        <tbody>{schedule.map((match) => <tr key={match.id}>
          <td>{editing ? <input aria-label={`День ${match.id}`} className="fed-input" style={{ width: 80 }} type="number" min="1" max="365" required value={match.day} onChange={(event) => setDraft({ ...draft, [match.id]: { day: Math.max(1, Math.min(365, Number(event.target.value) || 1)), time: match.time } })} /> : match.day}</td>
          <td>{editing ? <input aria-label={`Время ${match.id}`} className="fed-input" type="time" required value={match.time} onChange={(event) => { if (event.target.value) setDraft({ ...draft, [match.id]: { day: match.day, time: event.target.value } }); }} /> : match.time}</td>
          <td>{match.group ? `Группа ${match.group} · ` : ''}{match.label}</td>
          <td>{bracket.names[match.a] || match.aSource.label} — {bracket.names[match.b] || match.bSource.label}</td>
        </tr>)}</tbody>
      </table>
    </div>
    {editing && <div className="flex gap-3 mt-3">
      <button type="button" disabled={busy} className="fed-btn-primary px-3 py-2" onClick={save}>{busy ? 'Сохранение…' : 'Сохранить расписание'}</button>
      <button type="button" disabled={busy} className="fed-btn-ghost px-3 py-2" onClick={() => setEditing(false)}>Отмена</button>
    </div>}
  </section>;
}
